/* istanbul ignore file */

import * as Sentry from '@sentry/react';
import { Integration } from '@sentry/types';
import { BrowserTracing } from '@sentry/tracing';

import { env } from 'utils/env';

const debug = process.env.NODE_ENV !== 'production';
const environment = env.STAGE || 'dev';
const dsn = env.SENTRY_DSN;

const integrations =
  env.STAGE === 'prod' ? [new BrowserTracing() as Integration] : [];

/**
 * References
 * - https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/
 * - https://gist.github.com/impressiver/5092952
 */
const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  // Classroom errors
  /ResizeObserver loop limit exceeded/,
  /Loading chunk/,
  /Loading CSS chunk/,
  /currentTarget, isTrusted, target, type/,
  /Unexpected token '<'/,
  /AbortError/,
];

const allowUrls = [/classting.(com|net|dev)/];

Sentry.init({
  dsn,
  integrations,
  debug,
  environment,
  ignoreErrors,
  allowUrls,
  sampleRate: 0.1,
  tracesSampleRate: 0.1,
});

export {};
